export default __webpack_public_path__ + "static/media/kit_image.9162f683.png";